import type { FC } from 'react';

import ProjectLayout from './ProjectLayout';

type ProjectLayoutContainerProps = {
    activeItem: string;
    sticky?: boolean;
};

const ProjectLayoutContainer: FC<ProjectLayoutContainerProps> = ({ activeItem, sticky = false, children }) => (
    <ProjectLayout activeItem={activeItem} sticky={sticky}>
        {children}
    </ProjectLayout>
);

export default ProjectLayoutContainer;
